import { render, staticRenderFns } from "./SessionsChart.vue?vue&type=template&id=19cdaba0&scoped=true"
import script from "./SessionsChart.vue?vue&type=script&lang=js"
export * from "./SessionsChart.vue?vue&type=script&lang=js"
import style0 from "./SessionsChart.vue?vue&type=style&index=0&id=19cdaba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cdaba0",
  null
  
)

export default component.exports